module.exports = __webpack_public_path__ + "static/media/grass.8d96248e.jpg";